import DefaultHostView from "@/views/host/DefaultHostView";
import HostSelectionVoucherView from "@/views/host/voucher/HostSelectionVoucherView";
import HostDiscountVoucherView from "@/views/host/voucher/HostDiscountVoucherView";

export const HostViewComponents = {
    1:DefaultHostView,
    2:HostSelectionVoucherView,
    3:HostDiscountVoucherView,
}
